<script setup>
import { useToast } from '@/shared/composables/useToast.js';

const { toasts, removeToast } = useToast();

const isDev = import.meta.env.DEV || import.meta.env.MODE === 'staging';

const typeStyles = {
  error: { bg: 'bg-red-900', header: 'text-red-300', label: '錯誤' },
  success: { bg: 'bg-green-800', header: 'text-green-300', label: '成功' },
  warning: { bg: 'bg-yellow-700', header: 'text-yellow-200', label: '警告' },
  info: { bg: 'bg-blue-800', header: 'text-blue-200', label: '提示' },
};
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 w-[22.5rem]"
    >
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="text-white rounded shadow-lg p-3 text-sm font-mono leading-relaxed"
          :class="
            toast.method
              ? 'bg-red-900'
              : (typeStyles[toast.type]?.bg ?? 'bg-red-900')
          "
        >
          <div class="flex justify-between items-start gap-2">
            <div class="flex-1 min-w-0">
              <template v-if="toast.method">
                <div class="font-bold text-red-300 mb-1">
                  系統錯誤 {{ toast.status ? `[${toast.status}]` : '' }}
                </div>
                <template v-if="isDev">
                  <div class="text-gray-300 truncate">
                    {{ toast.method?.toUpperCase() }} {{ toast.url }}
                  </div>
                  <div class="text-white mt-1 break-words">
                    {{ toast.message }}
                  </div>
                </template>
                <template v-else>
                  <div class="text-white mt-1">
                    請稍後再試，或聯繫系統管理員
                  </div>
                </template>
              </template>
              <template v-else>
                <div
                  class="font-bold mb-1"
                  :class="typeStyles[toast.type]?.header ?? 'text-red-300'"
                >
                  {{ typeStyles[toast.type]?.label ?? '錯誤' }}
                </div>
                <div class="text-white break-words">{{ toast.message }}</div>
              </template>
            </div>
            <button
              class="text-gray-400 hover:text-white shrink-0 text-lg leading-none"
              @click="removeToast(toast.id)"
            >
              ×
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
